import React from 'react'
import { ActivityIndicator, StyleSheet, View } from 'react-native'
import theme from '../../../../theme'
import styles from './LoaderStyles'

export const Loader = () => {
    return (
        <View style={styles.container}>
            <View style={styles.loading}>
                <ActivityIndicator color={theme.colors.colorPrimary} size={50} />
            </View>
        </View>
    )
}

export const LoaderCustomAlert = () => {
    return (
        <View style={styles.containerCustomAlert}>
            <View style={styles.loading}>
                <ActivityIndicator color={'white'} size={50} />
            </View>
        </View>
    )
}

export const LoaderImage = () => {
    return (
        <View style={styles.loadingImage}>
            <ActivityIndicator color={theme.colors.colorPrimary} size={'large'} />
        </View>
    )
}
